import React from 'react';
import LoanCalc from './pages/LoanCalc';

const App = () =>  {
  return (
    <div>
      <LoanCalc />
    </div>
  );
}

export default App;
